import React, { useEffect, useRef } from 'react';
import { BusinessAutomationActionTypeEnum } from '@reach/shared-types/business-automation';
import { MessageSquare, Clock, Calendar, Users, type LucideIcon } from 'lucide-react';
import styles from './AddStepButton.module.css';

const { addStepMenu } = styles;

const {
  SEND_COMMUNICATION,
  WAIT_FOR_DURATION,
  WAIT_UNTIL_AT_LEAST_NEXT_AVAILABLE_TIME,
  CHECK_SEGMENT_MEMBERSHIP,
} = BusinessAutomationActionTypeEnum;

const menuOptions: { type: string; label: string; Icon: LucideIcon }[] = [
  { type: SEND_COMMUNICATION, label: 'Send Message', Icon: MessageSquare },
  { type: WAIT_FOR_DURATION, label: 'Wait', Icon: Clock },
  {
    type: WAIT_UNTIL_AT_LEAST_NEXT_AVAILABLE_TIME,
    label: 'Wait Until',
    Icon: Calendar,
  },
  { type: CHECK_SEGMENT_MEMBERSHIP, label: 'Check Audience', Icon: Users },
];

export const AddStepMenu: React.FC<{
  onSelect: (actionType: string) => void;
  onClose: () => void;
}> = ({ onSelect, onClose }) => {
  const menuRef = useRef<HTMLMenuElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const isNode = event.target instanceof Node;
      if (isNode && menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  return (
    <menu ref={menuRef} className={addStepMenu}>
      {menuOptions.map(({ type, label, Icon }) => (
        <button key={type} onClick={() => onSelect(type)}>
          <Icon />
          <span>{label}</span>
        </button>
      ))}
    </menu>
  );
};
